import React from "react";
import "./App.css";
import Main from "./components/Main/Main";
import GymProgram from "./components/Program/Program";
import Member from "./components/Member/Member";
import Classes from "./components/OurClasses/Classes";
import Schedule from "./components/Schedule/Schedule";
import Trainers from "./components/Executive/Executive";
import Contact from './components/Contact/Contact';

const App = () => (
  <div className="App">
    <marquee>
   <h2>To be updated soon!</h2>
   </marquee>
  </div>
);

export default App;
///// <Main />
   // <GymProgram />
   // <Member />
    //<Classes />
    //<Schedule />
    ///<Trainers />
    
   // <Contact />